import { render, staticRenderFns } from "./FrontWrapper.vue?vue&type=template&id=b5276540&"
import script from "./FrontWrapper.vue?vue&type=script&lang=js&"
export * from "./FrontWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports